import { Component, computed, inject } from '@angular/core';
import { ContractingService } from 'src/app/shared/services/contracting.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
@Component({
    imports: [
        CardModule,
        ButtonModule,
        MessageModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
    ],
    selector: 'app-contracting-acces',
    standalone: true,
    templateUrl: './contracting-acces.component.html',
    providers: [MessageService],
    styles: []
})
export class ContractingAccesComponent {

  private contractService = inject( ContractingService );
  private messageService = inject( MessageService );
  private router = inject( Router );

  public op = computed(() => this.contractService.currentOperation() );
  private pass = this.op()?.seller?.dni?.number;

  public inputPass:string = '';
  public loading:boolean =  false;

  validateAccess() {
    if (this.inputPass === '') return;
    this.loading =  true;
    if (this.inputPass === this.pass!) {
      this.loading =  false;
      this.router.navigate(['contracting/' + this.op()!.uid + '/sign']);
    } else {
      this.addMessage('error', 'El documento de identidad no coincide');
      this.loading =  false;
      return;
    }
  }

  private addMessage(severity:string, message:string) {
    this.messageService.add({severity: severity, summary:message});
}

}
